import {loadScript} from 'elead-ui-tool-v3'


function libFlowInstance() {
}
export const libFlowPackageMethods = new libFlowInstance()
export const installLibMethods = (res) => {
	for (const i in res) {
		libFlowInstance.prototype[i] = res[i]
	}
}


loadScript({
	urlObjs: [
		{
			url: 'https://itest.e-lead.cn/resources/font-awesome.min.oa.css'
		}
	]
})